import { render, staticRenderFns } from "./SuggestionsInput.vue?vue&type=template&id=ba90f820&"
import script from "./SuggestionsInput.vue?vue&type=script&lang=js&"
export * from "./SuggestionsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports